import { ArrowRight } from "lucide-react";
import { useLeadModal } from "../../context/LeadModalContext";

export default function FinalCTA() {
    const { openModal } = useLeadModal();

    return (
        <section
            data-testid="final-cta-section"
            className="relative py-24 sm:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-[#00f0ff]/[0.05] blur-[140px]" />
            </div>

            <div className="relative max-w-5xl mx-auto px-6 sm:px-10 lg:px-16">
                <div className="relative rounded-3xl bg-gradient-to-br from-[#0a1325] via-[#0a1325] to-[#021b3a] border border-[#00f0ff]/30 overflow-hidden">
                    <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
                    <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-[#1d4ed8]/15 blur-3xl" />

                    <div className="relative p-10 sm:p-16 text-center">
                        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00f0ff]/10 border border-[#00f0ff]/30 mb-7">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#00f0ff] animate-pulse" />
                            <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#00f0ff]">
                                Booking December — limited slots
                            </span>
                        </div>
                        <h2 className="font-heading text-4xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95]">
                            Stop reading.{" "}
                            <span className="text-gradient-cyan">Start shipping.</span>
                        </h2>
                        <p className="mt-7 max-w-2xl mx-auto text-lg text-[#94a3b8] leading-relaxed">
                            A real agent live in your stack — fast. Zero fluff. We scope, build,
                            and deploy before most agencies finish their proposal.
                        </p>
                        <div className="mt-9 flex justify-center">
                            <button
                                onClick={() => openModal("final-cta")}
                                data-testid="final-cta-trial-btn"
                                className="group inline-flex items-center gap-2 px-7 py-4 rounded-lg bg-[#00f0ff] text-[#050b14] font-bold hover:bg-white transition-colors duration-300"
                            >
                                Start building
                                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
